<!--
	Header.svelte
-->

<script>
    import { onMount } from 'svelte';
    import { push } from "svelte-spa-router";
	import { signIn, signOut } from '../../common/auth.js';

    // TCARE components
    import HamburgerMenu from './HamburgerMenu.svelte';
    import LogoWide from './LogoWide.svelte';
    import UserAvatar from './UserAvatar.svelte';

    export let user;                    // passed in from BaseLayoutPage - not from userStore

    onMount(() => {
        // console.log('Header onMount passed in user prop: ', user)
    })

    const onLoginClick = () => {
        console.log('onLoginClick');
        signIn();
    }

</script>

<style>
    .app-header {
        user-select: none;
        z-index: 900;
        width: 90%;
        padding: 0px 5%;
        height: 50px;
        font-size: 1.0em;
        color: var(--tcare-white);
        justify-content: space-between;
        background-color: var(--tcare-purple);
    }

    .app-header .left {
        cursor: pointer;
        width: 240px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        /* border: 1px solid red; */
    }

    .app-header .center {
        cursor: pointer;
        max-width: 180px;
        /* border: 1px solid green; */
    }

    .app-header .right {
        cursor: pointer;
        width: 240px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        /* border: 1px solid blue; */
    }

    .app-header .right div {
        min-width: 50px;
        margin-left: 15px;
    }

    .app-header .right div:hover {
        color: var(--tcare-secondary);
    }

    /*
    .app-header .help {
        cursor: pointer;
    }

    .app-header .register {
        cursor: pointer;
    }

    .app-header .login {
        cursor: pointer;
    }
    */


    @media screen and (max-width: 600px) {
        .app-header {
            height: 50px;
        }
        .app-header .left {
            max-width: 120px;
        }
        .app-header .center {
            width: 140px;
        }
        .app-header .right {
            max-width: 220px;
            display: flex;
        }

    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="app-header fixed-top flex-row">
    {#if user.isLoggedIn}
        <!-- show L, C, R -->
        <div class="left">
            <HamburgerMenu {user}/>
        </div>
        <div class="center">
            <LogoWide/>
        </div>
        <div class="right">
            <UserAvatar {user}/>
        </div>
    {:else}
        <!-- only L and R for non-logged in users -->
        <div class="left">
            <LogoWide/>
        </div>
        <div class="right">
            <!--
                <div class="help" on:click={() => push('/help')}>Help</div>
                <div class="register" on:click={() => push('/register')}>Register</div>    
                <div class="login" on:click={() => onLoginClick()}>Login</div>
            -->
        </div>
    {/if}
</div>
